import { Pipe, PipeTransform } from '@angular/core';
import { PeopleCurrentUpcomingTeamsSummary } from '../models/team/peopleCurrentUpcomingTeamsSummary';
import { TeamService } from '../services/team.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Pipe({
  name: 'currentOrUpcomingTeamsSummary',
  standalone: false
})
export class currentOrUpcomingTeamsSummaryPipe implements PipeTransform {
  constructor(private teamService: TeamService) {}
  public transform(personId: string, teams: string): Observable<number> {
    return this.teamService.peopleCurrentUpcomingSummary.pipe(
      map((result) => {
        if (result) {
          const personUpcomingTeam: PeopleCurrentUpcomingTeamsSummary = result[personId];
          if (personUpcomingTeam) {
            return teams == 'current'
              ? personUpcomingTeam.currentTeams
              : personUpcomingTeam.upcomingTeams; //teams == 'upcoming'
          }
        }
        return 0;
      })
    );
  }
}
